import { render } from "./ImportExportGallery.vue?vue&type=template&id=713c4578&scoped=true&ts=true"
import script from "./ImportExportGallery.vue?vue&type=script&lang=ts"
export * from "./ImportExportGallery.vue?vue&type=script&lang=ts"

import "./ImportExportGallery.vue?vue&type=style&index=0&id=713c4578&lang=scss&scoped=true"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-713c4578"]])

export default __exports__